import { domain } from "../auth/domain";

const authHeaders = () => {
  const token = localStorage.getItem("accessToken");
  if (!token) {
    throw new Error("Missing session. Please login again.");
  }
  return {
    Authorization: `JWT ${token}`,
    "Content-Type": "application/json",
  };
};

const looksLikeHtml = (value) => /<(?:!doctype|html|head|body)\b/i.test(value || "");

export const parseAuditApiError = async (response, fallbackMessage) => {
  const text = await response.text();
  let payload = null;
  try {
    payload = text ? JSON.parse(text) : null;
  } catch (_error) {
    payload = null;
  }

  const message =
    payload?.detail ||
    payload?.description ||
    payload?.message ||
    (!looksLikeHtml(text) ? text : "") ||
    fallbackMessage;
  const error = new Error(message);
  error.status = response.status;
  throw error;
};

const handleResponse = async (response) => {
  if (!response.ok) {
    return parseAuditApiError(
      response,
      "Unable to load transaction activity right now.",
    );
  }
  return response.json();
};

export const fetchTransactionAudit = async (params = {}) => {
  const query = new URLSearchParams(params).toString();
  const endpoint = query ? `${domain}contributions/audit/?${query}` : `${domain}contributions/audit/`;
  const resp = await fetch(endpoint, {
    method: "GET",
    headers: authHeaders(),
  });
  return handleResponse(resp);
};

export const fetchBillableStatement = async (params = {}) => {
  const query = new URLSearchParams(params).toString();
  const endpoint = query
    ? `${domain}contributions/statement-download/?${query}`
    : `${domain}contributions/statement-download/`;
  const resp = await fetch(endpoint, {
    method: "GET",
    headers: authHeaders(),
  });
  if (resp.status === 402) {
    const invoice = await resp.json();
    const err = new Error("Payment required");
    err.invoice = invoice?.invoice || invoice;
    err.status = 402;
    throw err;
  }
  if (!resp.ok) {
    return parseAuditApiError(
      resp,
      "Unable to download the statement right now.",
    );
  }
  return resp.json();
};
